import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";

import {MaterialCommonModule} from "src/app/material-modules/material-common.module";
import {ComboEixoModule} from "../common/combo-eixo/combo-eixo.module";
import {CadastrarPercursoComponent} from "./cadastrar-percurso/cadastrar-percurso.component";
import {PercursoRoutingModule} from "./percurso-routing.module";
import {PercursoComponent} from "./percurso.component";

@NgModule({
    declarations: [PercursoComponent, CadastrarPercursoComponent],
    imports: [
        CommonModule,
        PercursoRoutingModule,
        MaterialCommonModule,
        ComboEixoModule,
    ],
})
export class PercursoModule {
}
